(function(){
  const giftSettings = {
    enabled: true,
    variantId: "51484062974298",
    threshold: 100,
    message: "Complimentary Travel Size Body Treatment"
  };

  if (!giftSettings.enabled || !giftSettings.variantId || !giftSettings.threshold) return;

  const thresholdCents = parseFloat(giftSettings.threshold) * 100;

  function fetchCart() {
    return fetch('/cart.js').then(r => r.json());
  }

  function showGiftMessage(msg) {
    if (!msg) return;
    let notice = document.getElementById('gwp-message');
    if (!notice) {
      notice = document.createElement('div');
      notice.id = 'gwp-message';
      notice.className = 'gwp-message';
      document.body.appendChild(notice);
    }
    notice.textContent = msg;
  }

  function removeGiftMessage() {
    const notice = document.getElementById('gwp-message');
    if (notice) notice.remove();
  }

  function publishUpdate(cart) {
    if (typeof publish === 'function') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gift-with-purchase', cartData: cart });
    }
  }

  function addGift() {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: giftSettings.variantId, quantity: 1, properties: { _gift_with_purchase: true } })
    })
    .then(fetchCart)
    .then(cart => {
      publishUpdate(cart);
      removeGiftMessage();
    })
    .catch(err => console.error('Gift add failed', err));
  }

  function changeLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(fetchCart).then(cart => {
      publishUpdate(cart);
      return cart;
    });
  }

  function updateGift(cart) {
    const giftIndex = cart.items.findIndex(item => item.properties && item.properties._gift_with_purchase);
    const hasGift = giftIndex !== -1;

    if (cart.items_subtotal_price >= thresholdCents) {
      if (!hasGift) {
        showGiftMessage(giftSettings.message);
        addGift();
      } else if (cart.items[giftIndex].quantity > 1) {
        changeLine(giftIndex + 1, 1);
      }
    } else if (hasGift) {
      changeLine(giftIndex + 1, 0);
    }
    if (hasGift) {
      removeGiftMessage();
    }
  }

  function handleEvent(event) {
    if (event && event.cartData && typeof event.cartData.items_subtotal_price !== 'undefined') {
      updateGift(event.cartData);
    } else {
      fetchCart().then(updateGift);
    }
  }

  if (typeof subscribe === 'function') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, handleEvent);
  }

  document.addEventListener('DOMContentLoaded', () => {
    fetchCart().then(updateGift);
  });
})();
